import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setFilterThing } from "./thingSlice";

export const fetchThingDetails = createAsyncThunk(
  "thing/fetchThingDetails",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        method: "get",
        maxBodyLength: Infinity,
        url: "https://v4.dhundhoo.com/v2/things/my",
        headers: {
          "x-dhundhoo-session": token,
        },
      };

      const response = await axios.request(config);
      console.log(response.data, "dataattataattat");

      const orgThings = response.data?.orgThings || {};
      const thingsArray = Object.keys(orgThings).map((thingId) => ({
        id: thingId,
        ...orgThings[thingId].thing,
      }));
      dispatch(setFilterThing(thingsArray));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
